import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { Routes } from 'core/routes.types';
import { useSelector } from 'react-redux';
import { getBrand } from 'redux/brand';

export type PaymentStep = 'choose_payment_method' | 'stripe_order_confirmation';
export type PaymentMode = 'stripe' | 'ewallet';

export const useTermsAndConditionsVM = () => {
    const navigate = useNavigate();
    const brand = useSelector(getBrand);

    const goBack = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    const goBackToMenu = useCallback(() => {
        navigate(Routes.MenuHome);
    }, [navigate]);

    return {
        goBack,
        goBackToMenu,
        brandName: brand?.name ?? '',
    };
};
